import React from 'react';
import { motion } from 'framer-motion';
import { Moon } from 'lucide-react';
export function Hero() {
  return <section className="relative w-full bg-navy text-cream overflow-hidden pt-20 pb-24 lg:pt-32 lg:pb-40" data-id="element-32">
      {/* Decorative stars */}
      <div className="absolute top-10 left-10 opacity-20" data-id="element-33">
        <Moon size={48} className="text-amber" data-id="element-34" />
      </div>
      <div className="absolute top-40 right-20 opacity-10" data-id="element-35">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className="text-amber" data-id="element-36">
          <path d="M12 0L14.59 9.41L24 12L14.59 14.59L12 24L9.41 14.59L0 12L9.41 9.41L12 0Z" data-id="element-37" />
        </svg>
      </div>
      <div className="absolute bottom-20 left-1/4 opacity-10" data-id="element-38">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" className="text-amber" data-id="element-39">
          <path d="M12 0L14.59 9.41L24 12L14.59 14.59L12 24L9.41 14.59L0 12L9.41 9.41L12 0Z" data-id="element-40" />
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10" data-id="element-41">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-42">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="max-w-2xl" data-id="element-43">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-serif font-medium leading-tight mb-6" data-id="element-44">
              Recupera tus noches (y tu cordura) en solo 7 días,{' '}
              <span className="text-amber italic" data-id="element-45">
                sin dejar a tu bebé llorar solo.
              </span>
            </h1>
            <p className="text-lg sm:text-xl text-cream/80 mb-10 leading-relaxed font-light" data-id="element-46">
              El método de "Cercanía Gradual" diseñado para madres agotadas que
              buscan una solución humana, respetuosa y efectiva para el sueño
              infantil.
            </p>
            <motion.button whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} onClick={() => document.getElementById('price-block')?.scrollIntoView({
            behavior: 'smooth'
          })} className="w-full sm:w-auto bg-amber hover:bg-amber-hover text-navy font-semibold text-lg py-4 px-8 rounded-full shadow-lg transition-colors duration-300 text-center" data-id="element-47">
              QUIERO RECUPERAR MIS NOCHES AHORA
            </motion.button>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 1,
          delay: 0.2,
          ease: 'easeOut'
        }} className="relative mx-auto w-full max-w-md lg:max-w-none" data-id="element-48">
            <div className="aspect-[4/5] lg:aspect-square rounded-2xl overflow-hidden shadow-2xl relative" data-id="element-49">
              <div className="absolute inset-0 bg-navy/20 z-10 mix-blend-multiply" data-id="element-50"></div>
              <img src="https://cdn.magicpatterns.com/uploads/mNeKHw8KTjhkgNPHmtmmYR/portada_dulces_suenos.png" alt="Madre observando a su bebé dormir plácidamente" className="w-full h-full object-cover object-center" data-id="element-51" />
            </div>
            {/* Decorative element behind image */}
            <div className="absolute -inset-4 bg-amber/10 rounded-3xl -z-10 transform rotate-3" data-id="element-52"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}